import { useCallback, useEffect, useMemo, useState } from "react";
import { fetchOtherStore } from "../../visoria/api";

export const NINTENDO_STORE_ID = "nintendo";

/** Регион скидок → регион карт в каталоге магазина. */
export const CARD_REGION = {
  us: "usd",
  fr: "eur",
  br: "brl",
  ca: "cad",
  pl: "pln",
  se: "sek",
};

const cache = new Map();

function loadStore(storeId, force) {
  if (!cache.has(storeId) || force) {
    cache.set(
      storeId,
      fetchOtherStore(storeId).catch((error) => {
        cache.delete(storeId);
        throw error;
      }),
    );
  }
  return cache.get(storeId);
}

export function toCards(region) {
  const seen = new Set();
  const denominations = (region?.denominations || [])
    .filter((item) => {
      if (!item?.id || !(item.faceValue > 0) || seen.has(item.id)) {
        return false;
      }
      seen.add(item.id);
      return true;
    })
    .map((item) => ({
      id: item.id,
      label: item.label,
      face: Number(item.faceValue),
      currency: item.currencyCode,
      priceRub: item.priceRub,
      priceCryptoUsdt: item.priceCryptoUsdt || 0,
      stock: item.stockAvailable || 0,
    }));
  return {
    regionId: region?.id,
    label: region?.label,
    currency: denominations[0]?.currency,
    denominations,
  };
}

/** Номиналы карт магазина с id товаров и ценами — как в магазине на сайте. */
export function useStoreCards(storeId) {
  const [store, setStore] = useState(null);
  const [error, setError] = useState(false);

  const refresh = useCallback(
    (force = true) =>
      loadStore(storeId, force)
        .then((data) => {
          setStore(data);
          setError(false);
        })
        .catch(() => setError(true)),
    [storeId],
  );

  useEffect(() => {
    refresh(false);
  }, [refresh]);

  const byRegion = useMemo(
    () =>
      Object.fromEntries((store?.regions || []).map((region) => [region.id, toCards(region)])),
    [store],
  );
  const cardsFor = useCallback((cardRegion) => byRegion[cardRegion] || null, [byRegion]);

  return { loaded: Boolean(store), error, cardsFor, refresh };
}

export const useNintendoCards = () => useStoreCards(NINTENDO_STORE_ID);
